import { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  width?: number
  height?: number
}

export const DailyRewardImageGems = ({
  width = 174,
  height = 145,
  ...props
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 174 145"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.2" filter="url(#filter0_f_62717_79256)">
        <ellipse
          cx="87.0576"
          cy="106.224"
          rx="61.9424"
          ry="13.2238"
          fill="url(#paint0_linear_62717_79256)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter1_f_62717_79256)">
        <path
          d="M130.896 111.628C130.896 112.91 110.788 117.448 84.711 117.448C58.6339 117.448 37.4943 116.408 37.4943 115.126C5.83376 112.085 60.9515 99.5981 87.0285 99.5981C113.106 99.5981 130.896 110.346 130.896 111.628Z"
          fill="url(#paint1_linear_62717_79256)"
        />
      </g>
      <g opacity="0.3" filter="url(#filter2_f_62717_79256)">
        <ellipse
          cx="77.8098"
          cy="112.891"
          rx="55.8098"
          ry="6.55701"
          fill="url(#paint2_linear_62717_79256)"
        />
      </g>
      <g opacity="0.3" filter="url(#filter3_f_62717_79256)">
        <ellipse
          cx="81.008"
          cy="115.178"
          rx="48.1926"
          ry="2.63452"
          fill="url(#paint3_linear_62717_79256)"
        />
      </g>
      <path
        d="M85.6409 31.701C85.7735 31.4714 85.9919 31.3038 86.2481 31.2351L108.424 25.293C108.681 25.2244 108.954 25.2603 109.183 25.3929L121.68 32.6081C121.91 32.7407 122.078 32.9591 122.146 33.2153L128.088 55.3916C128.157 55.6478 128.121 55.9207 127.988 56.1504L108.147 90.5173C108.014 90.747 107.796 90.9146 107.539 90.9833L85.3632 96.9254C85.107 96.994 84.8341 96.9581 84.6044 96.8255L72.1073 89.6103C71.8776 89.4777 71.71 89.2593 71.6414 89.0031L65.6993 66.8268C65.6306 66.5706 65.6665 66.2977 65.7992 66.068L85.6409 31.701Z"
        fill="#E96565"
        stroke="#60050F"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M66.6651 66.5679L86.5068 32.2009L95.9681 42.8705L80.6358 69.4268L66.6651 66.5679Z"
        fill="#EE8BBB"
      />
      <path
        d="M108.683 26.2589L86.5069 32.2011L95.9682 42.8706L110.422 37.6772L121.18 33.4741L108.683 26.2589Z"
        fill="#FFC1DF"
      />
      <path
        d="M97.8198 79.3479L83.3657 84.5413L72.6077 88.7444L85.1047 95.9596L107.281 90.0174L127.123 55.6505L121.181 33.4742L110.423 37.6773L113.152 52.7916L97.8198 79.3479Z"
        fill="#D74E67"
      />
      <path
        d="M127.122 55.6505L107.28 90.0174L97.8192 79.3478L113.152 52.7916L127.122 55.6505Z"
        fill="#AC2F6B"
      />
      <circle
        cx="119.489"
        cy="61.6571"
        r="1.8038"
        transform="rotate(30 119.489 61.6571)"
        fill="#BE3778"
      />
      <circle
        cx="113.703"
        cy="67.1688"
        r="1.35285"
        transform="rotate(30 113.703 67.1688)"
        fill="#BE3778"
      />
      <circle
        cx="117.564"
        cy="66.7945"
        r="0.901898"
        transform="rotate(30 117.564 66.7945)"
        fill="#BE3778"
      />
      <circle
        cx="115.011"
        cy="62.1964"
        r="0.901898"
        transform="rotate(30 115.011 62.1964)"
        fill="#BE3778"
      />
      <circle
        cx="122.976"
        cy="57.4217"
        r="0.901898"
        transform="rotate(30 122.976 57.4217)"
        fill="#BE3778"
      />
      <circle
        cx="112.152"
        cy="76.1671"
        r="0.901898"
        transform="rotate(30 112.152 76.1671)"
        fill="#BE3778"
      />
      <circle
        cx="114.407"
        cy="72.262"
        r="0.901898"
        transform="rotate(30 114.407 72.262)"
        fill="#BE3778"
      />
      <path
        d="M95.9687 42.8707L80.6364 69.4269L83.3658 84.5412L97.7988 79.3844L113.152 52.7915L110.423 37.6772L95.9687 42.8707Z"
        fill="#FF6480"
      />
      <path
        d="M80.6364 69.4269L95.9687 42.8707L110.423 37.6772L113.152 52.7915L80.6364 69.4269Z"
        fill="#FF9BAD"
      />
      <path
        d="M109.07 40.0202L97.0796 44.5534L87.6097 60.9558"
        stroke="#FFD5E4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.7168 35.446L69.5807 65.1266"
        stroke="#FFADD4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.0824 33.2236L108.563 28.2718"
        stroke="#FFE7F2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="100.296"
        cy="88.5878"
        r="1.35285"
        transform="rotate(30 100.296 88.5878)"
        fill="#B43B51"
      />
      <circle
        cx="87.9756"
        cy="91.889"
        r="1.35285"
        transform="rotate(30 87.9756 91.889)"
        fill="#B43B51"
      />
      <circle
        cx="92.9034"
        cy="90.5685"
        r="1.35285"
        transform="rotate(30 92.9034 90.5685)"
        fill="#B43B51"
      />
      <circle
        cx="90.5157"
        cy="86.5865"
        r="0.901898"
        transform="rotate(30 90.5157 86.5865)"
        fill="#B43B51"
      />
      <circle
        cx="95.9844"
        cy="89.7432"
        r="0.901898"
        transform="rotate(30 95.9844 89.7432)"
        fill="#B43B51"
      />
      <circle
        cx="95.4444"
        cy="85.266"
        r="1.8038"
        transform="rotate(30 95.4444 85.266)"
        fill="#B43B51"
      />
      <path
        d="M49.4453 51.7851C49.4453 51.5198 49.5507 51.2655 49.7382 51.0779L62.3382 38.478C62.5257 38.2904 62.7801 38.1851 63.0453 38.1851L74.2453 38.1851C74.5105 38.1851 74.7649 38.2904 74.9524 38.478L87.5524 51.0779C87.7399 51.2655 87.8453 51.5198 87.8453 51.7851L87.8453 82.585C87.8453 82.8503 87.7399 83.1046 87.5524 83.2921L74.9524 95.8921C74.7649 96.0797 74.5105 96.185 74.2453 96.185L63.0453 96.185C62.7801 96.185 62.5257 96.0797 62.3382 95.8921L49.7382 83.2921C49.5507 83.1046 49.4453 82.8503 49.4453 82.585L49.4453 51.7851Z"
        fill="#E96565"
        stroke="#60050F"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M50.4443 82.5851L50.4443 51.7852L60.9443 55.2852L60.9443 79.0851L50.4443 82.5851Z"
        fill="#EE8BBB"
      />
      <path
        d="M63.0453 39.1851L50.4453 51.7851L60.9453 55.2851L68.6453 46.1851L74.2453 39.1851L63.0453 39.1851Z"
        fill="#FFC1DF"
      />
      <path
        d="M76.3449 79.085L68.6449 88.185L63.0449 95.185L74.2449 95.185L86.8449 82.585L86.8449 51.7851L74.2449 39.1851L68.6449 46.1851L76.3449 55.2851L76.3449 79.085Z"
        fill="#D74E67"
      />
      <path
        d="M86.8437 51.7852L86.8437 82.5851L76.3437 79.0851L76.3437 55.2852L86.8437 51.7852Z"
        fill="#AC2F6B"
      />
      <circle cx="84.0455" cy="58.7853" r="1.4" fill="#BE3778" />
      <circle cx="82.2941" cy="64.7351" r="1.05" fill="#BE3778" />
      <circle cx="84.7439" cy="62.9854" r="0.7" fill="#BE3778" />
      <circle cx="81.2439" cy="60.8853" r="0.7" fill="#BE3778" />
      <circle cx="84.7439" cy="54.5853" r="0.7" fill="#BE3778" />
      <circle cx="84.7439" cy="71.3853" r="0.7" fill="#BE3778" />
      <circle cx="84.7439" cy="67.8853" r="0.7" fill="#BE3778" />
      <path
        d="M60.9453 55.2851L60.9453 79.085L68.6453 88.185L76.3453 79.1179L76.3453 55.2851L68.6453 46.1851L60.9453 55.2851Z"
        fill="#FF6480"
      />
      <path
        d="M60.9453 79.085L60.9453 55.2851L68.6453 46.1851L76.3453 55.2851L60.9453 79.085Z"
        fill="#FF9BAD"
      />
      <path
        d="M68.6437 48.2849L62.3438 55.9849V70.6849"
        stroke="#FFD5E4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.8447 53.885V80.485"
        stroke="#FFADD4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.2441 51.085L63.7441 40.585"
        stroke="#FFE7F2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="81.5959" cy="84.3347" r="1.05" fill="#B43B51" />
      <circle cx="74.5959" cy="91.3347" r="1.05" fill="#B43B51" />
      <circle cx="77.3947" cy="88.5349" r="1.05" fill="#B43B51" />
      <circle cx="74.2449" cy="86.785" r="0.7" fill="#B43B51" />
      <circle cx="79.1463" cy="86.7845" r="0.7" fill="#B43B51" />
      <circle cx="77.0455" cy="83.9847" r="1.4" fill="#B43B51" />
      <defs>
        <filter
          id="filter0_f_62717_79256"
          x="0.115234"
          y="68"
          width="173.885"
          height="76.4478"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="12.5"
            result="effect1_foregroundBlur_62717_79256"
          />
        </filter>
        <filter
          id="filter1_f_62717_79256"
          x="12.9551"
          y="84.5981"
          width="132.941"
          height="47.8496"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="7.5"
            result="effect1_foregroundBlur_62717_79256"
          />
        </filter>
        <filter
          id="filter2_f_62717_79256"
          x="17"
          y="101.333"
          width="121.619"
          height="23.114"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.5"
            result="effect1_foregroundBlur_62717_79256"
          />
        </filter>
        <filter
          id="filter3_f_62717_79256"
          x="29.8154"
          y="109.544"
          width="102.385"
          height="11.269"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_62717_79256"
          />
        </filter>
        <linearGradient
          id="paint0_linear_62717_79256"
          x1="87.0575"
          y1="89.7517"
          x2="87.0576"
          y2="119.448"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB9355" stopOpacity="0" />
          <stop offset="1" stopColor="#AC7D4B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_62717_79256"
          x1="86.7455"
          y1="95.8699"
          x2="86.4947"
          y2="117.468"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AC7D4B" stopOpacity="0.27" />
          <stop offset="0.919275" stopColor="#81674C" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_62717_79256"
          x1="128.979"
          y1="119.447"
          x2="22"
          y2="119.447"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB9355" stopOpacity="0" />
          <stop offset="0.50698" stopColor="#9C4844" />
          <stop offset="1" stopColor="#856139" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_62717_79256"
          x1="125.194"
          y1="117.813"
          x2="32.8154"
          y2="117.812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#95813A" stopOpacity="0" />
          <stop offset="0.50698" stopColor="#7D6922" />
          <stop offset="1" stopColor="#856139" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
